import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { I18NextPipe } from 'angular-i18next';
import { Subject } from 'rxjs';
import { State } from 'src/app/dashboards/state';
import { DashboardService } from 'src/app/services/services/dashboard.service';
import { BaseReportsDetailsComponent } from '../base/base-reports-details.component';

@Component({
    selector: 'app-rule-match-details',
    templateUrl: './rule-match-details.component.html',
    styleUrls: [
        './../base/base-reports-details.component.scss',
        './rule-match-details.component.scss'
    ],
    standalone: false
})

export class RuleMatchDetailsComponent extends BaseReportsDetailsComponent implements OnInit, OnChanges {

  viewReportSubject$: Subject<void> = new Subject<void>();

  constructor(protected dashboardsService: DashboardService, protected i18nextPipe: I18NextPipe, public dialog: MatDialog, protected store: Store<State>) {
    super(dashboardsService, i18nextPipe, dialog, store);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.reportId || changes.subReportId) {
      this.reportLoaded = false;
      this.loadReportData(changes.reportId?.currentValue || this.reportId, changes.subReportId?.currentValue || this.subReportId);
      this.expandSettings();
    }
  }

  setInitialSetup() {
    super.setInitialSetup();

    if(!this.subReportId){
      this.initialSetup.interactionIds = [];
      this.initialSetup.ruleIds = [];
    }
    this.initialSetup.columns = this.columns.map(col => col.labelCode);
  }

  viewReport() {
    this.viewReportSubject$.next();
  }

  reportFullscreen() {
    super.reportFullscreen();
  }

  loadReportData(reportId, subReportId) {
    this.dataLoaded = false;
    this.resetGridItem(reportId, subReportId);
    this.dashboardsService.getReport(reportId, subReportId).subscribe(report => {
      this.dataLoaded = true;
      this.report = report;

      this.gridItem.setup.subReportId = report.subReportId;

      if (!this.isFromDashboard) {
        let allColumns = report.allColumns.map(c => c.labelCode);
        this.gridItem.setup.columns = report.rawColumns?.filter(c => c && allColumns.includes(c)) ?? [];
      }

      this.columns = report.allColumns.sort((a, b) => Number(b.isKey) - Number(a.isKey) || a.order - b.order);
      if (!this.isFromDashboard || report.preset) {
        this.defaultColumns = report.defaultColumns.filter(x => !report.allColumns.find(c => c.labelCode === x)?.isKey);
      }

      if (report.preset) {
        this.gridItem.setup = { ...this.gridItem.setup, ...report.preset };
        this.gridItem.type = report.preset.reportType;
        this.gridItem.setup.columns = report.defaultColumns;
      }

      this.setInitialSetup();

      this.reportModifiedNotifier.emit(false);
      this.reportLoaded = true;
      this.reportLoadedNotifier.emit(true);
    });
  }
}
